
<template>


    <div>


<v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
<v-btn
          :color="mensaje.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>



  <EditarProductoDialog ref="editarProductoDialog" @actualizado="despuesDeActualizar"></EditarProductoDialog>

  
  <CategoriaDialog2 ref="componenteEnPadre" @actualizado="despuesDeActualizarPadreProducto"></CategoriaDialog2>


 <!-- <h3>{{producto}}</h3>   -->

    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Registro de Productos</v-toolbar-title>
      </v-toolbar>
      <v-tabs v-model="tab">
       
       <v-tab href="#one">
          <v-icon left>mdi-account</v-icon>
          Registro
        </v-tab>
        
        <v-tab href="#two" >
          <v-icon left>mdi-dns</v-icon>
          Listado
        </v-tab>
    </v-tabs>
         <v-tabs-items :value="tab"> 
          <!-- <div :value="tab"> -->
        <v-tab-item value="one">
          <v-card flat>
            <v-card-text>
               <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >

<v-row>
    <!-- inicio campos -->

     <!-- Descripción -->
        <v-col cols="12" md="6" lg="6">
          <v-text-field
            v-model="producto.descripcion"
            label="Descripción"
            :rules="textRules"
            required
               outlined
               
          ></v-text-field>
        </v-col>



        <!-- Subcampos -->
  <v-col cols="12" md="6" lg="6">
    <v-text-field
      v-model="producto.sub1"
      label="Sub 1"
      outlined
      dense
    ></v-text-field>
  </v-col>

  <v-col cols="12" md="6" lg="6">
    <v-text-field
      v-model="producto.sub2"
      label="Sub 2"
      outlined
      dense
    ></v-text-field>
  </v-col>

  <v-col cols="12" md="6">
    <v-text-field
      v-model="producto.sub3"
      label="Sub 3"
      outlined
      dense
    ></v-text-field>
  </v-col>

  <v-col cols="12" md="6">
    <v-text-field
      v-model="producto.sub4"
      label="Sub 4"
      outlined
      dense
    ></v-text-field>
  </v-col>

  <v-col cols="12" md="6">
    <v-text-field
      v-model="producto.sub5"
      label="Sub 5"
      outlined
      dense
    ></v-text-field>
  </v-col>

  <!-- Info (texto largo) -->
  <v-col cols="12">
    <v-textarea
      v-model="producto.info"
      label="Información detallada"
      auto-grow
      outlined
      rows="6"
      counter="1048576"
      hint="Máximo 1MB de texto (~1 millón de caracteres)"
      persistent-hint
    ></v-textarea>
  </v-col>




        <!-- Estado (radio) -->
        <v-col cols="12" md="6">
          <v-radio-group v-model="producto.estado" row>
            <v-radio label="Activo" value="activo"></v-radio>
            <v-radio label="Inactivo" value="inactivo"></v-radio>
          </v-radio-group>
        </v-col>

        <!-- Modelo -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.modelo"
            label="Modelo"
          ></v-text-field>
        </v-col>

        <!-- Última compra (string por ahora) -->
       <template>
               <v-text-field
                 v-model="dateFormatted"
                 label="Date"
                 hint="DD-MM-YYYY format"
                 persistent-hint
                 prepend-icon="mdi-calendar"      
                 @blur="date = parseDate(dateFormatted)" 
               ></v-text-field>
             </template>
             <v-date-picker
               v-model="date"
               no-title
               @input="menu1 = false"
             ></v-date-picker>

        <!-- Código barra -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.codigo_barra"
            label="Código de barra"
          ></v-text-field>
        </v-col>

        <!-- Cantidad total -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.cantidad_total"
            label="Cantidad total"
            type="number"
          ></v-text-field>
        </v-col>

        <!-- Utilidad -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.utilidad"
            label="Utilidad"
            type="number"
          ></v-text-field>
        </v-col>

        <!-- Utilidad2 -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.utilidad2"
            label="Utilidad 2"
            type="number"
          ></v-text-field>
        </v-col>

        <!-- Utilidad3 -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.utilidad3"
            label="Utilidad 3"
            type="number"
          ></v-text-field>
        </v-col>

        <!-- PCU -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.pcu"
            label="PCU"
            type="number"
          ></v-text-field>
        </v-col>

        <!-- PVU -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.pvu"
            label="PVU"
            type="number"
          ></v-text-field>
        </v-col>

        <!-- PVU2 -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.pvu2"
            label="PVU2"
            type="number"
          ></v-text-field>
        </v-col>

        <!-- PVU3 -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.pvu3"
            label="PVU3"
            type="number"
          ></v-text-field>
        </v-col>

        <!-- Observaciones -->
        <v-col cols="12">
          <v-text-field
            v-model="producto.obs"
            label="Observaciones"
          ></v-text-field>
        </v-col>

        <!-- Link photo -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.link_photo"
            label="Link foto"
            disabled
          ></v-text-field>
        </v-col>

        <!-- Icon -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.icon"
            label="Icon"
            v-if="false"
          ></v-text-field>
        </v-col>

        <!-- Zoom -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.zoom"
            label="Zoom"
            type="number"
            v-if="false"
          ></v-text-field>
        </v-col>

        <!-- Fotox -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.fotox"
            label="Foto X"
            type="number"
            v-if="false"
          ></v-text-field>
        </v-col>

        <!-- Fotoy -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.fotoy"
            label="Foto Y"
            type="number"
            v-if="false"
          ></v-text-field>
        </v-col>

        <!-- Proveedor_id (disabled) 
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.proveedor.nombre"
            label="Proveedor"
            type="text"
            disabled
          ></v-text-field>
        </v-col>-->



<v-btn color="primary" @click="openCategoriaDialog()">Seleccionar Categoria del Producto</v-btn>
        <!-- Categoria_id (disabled) -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.categoria.descripcion"
            label="Descripción de la Categoría"
            type="text"
            disabled
          ></v-text-field>
        </v-col>
   
    <!-- <v-row no-gutters>
      <v-col order="first" class="mb-6">
        <categoria  
        class="pa-2"
        outlined
        tile @guardarCategoria="recibirCategoria">     </categoria>

        </v-col>
      <v-col>
      </v-col>

      <v-col order="last">
        
      </v-col>
     
    </v-row> -->
   
   <!-- fin campos -->

</v-row>


 <v-row no-gutters>
      
      <v-col>
      </v-col>

      <v-col order="last">
        
      </v-col>
     
    </v-row>


      
      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="registrar"
      >
        Registrar
      </v-btn>

      <v-btn
        color="error"
        class="mr-4"
        @click="reset();"
      >
        Cancelar
      </v-btn>
  
    </v-form> 
            </v-card-text>


           <v-card-text>

            <v-alert
   
      colored-border
      type="info"
      elevation="2"
      
    >
      El presente registro es responsable de almacenar información sobre el Producto.<br>
      
    </v-alert>

          </v-card-text>




          </v-card>
        </v-tab-item>

   <!--  fin item 1-->
<v-tab-item value="two">
          <v-card flat>
            <v-card-text>

<v-text-field
            v-model="buscador" 
            placeholder="Ejemplo: Juan Perez"
            outlined
           
          >
          <template v-slot:label>
          <v-icon style="vertical-align: middle">
            mdi-magnify
          </v-icon>
          Busqueda por nombre de Producto
        </template>
          
          
          </v-text-field>



             
 <v-simple-table fixed-header>
    <template v-slot:default>


      <thead class="thead-dark">
       <tr>
  <th scope="col">ID</th>
  <th scope="col">Descripción</th>
  <th scope="col">Cantidad Total</th>
  <th scope="col">Utilidad</th>
  <th scope="col">PCU</th>
  <th scope="col">PVU</th>
  <th scope="col">Editar</th>
  <th scope="col">Eliminar</th>
</tr>

      </thead>
      <tbody>
        <tr v-for="producto in productosBuscados" :key="producto.id">       


<td>{{ producto.id }}</td>
  <td>{{ producto.descripcion }}</td>
  <td>{{ producto.cantidad_total }}</td>
  <td>{{ producto.utilidad }}</td>
  <td>{{ producto.pcu }}</td>
  <td>{{ producto.pvu }}</td>


          <td>
              
               <v-btn color="primary" @click="openEditarProductoDialog(producto)">
      <v-icon left>mdi-pencil</v-icon> Editar
    </v-btn>
            </td>
            <td>
              <button @click="eliminarProducto(producto)" class="btn"><v-icon left>mdi-delete-forever</v-icon></button>
            </td>
     
 </tr>
      </tbody>

    
    </template>
  </v-simple-table>

            </v-card-text>
          </v-card>
        </v-tab-item>

        <!--  fin item 2-->
     

      </v-tabs-items> 

          <!-- </div> -->
    </v-card>

  </div>
</template>


<script>


import productoService from "@/services/tienda/productoService.js";

import Categoria from '@/components/tienda/categoria/CategoriaDialog.vue'


import axios from 'axios'
import EditarProductoDialog from "@/components/tienda/producto/EditarProductoDialog.vue";

import CategoriaDialog2 from "@/components/tienda/categoria/CategoriaDialog2.vue";



export default {

     name: 'Producto',
    components: { EditarProductoDialog, Categoria,CategoriaDialog2 },

  computed: {
    tab: {
      set (tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
      },
      get () {
        return this.$route.query.tab
      }
    }
  },
    data: vm => ({



      mensaje:{
          snackbar: false,
          text: '',
          color:'',
          timeout: 5000,
      },

      productoSeleccionado: {},
    valid: true,
    tab:"",
    buscador:'',
showPass: false,
  productos: [],
        producto: {
        descripcion: "",
        sub1: "",
        sub2: "",
        sub3: "",
        sub4: "",
        sub5: "",
        info: "",
        estado: "activo",
        modelo: "",
        ultima_compra: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
        codigo_barra: "",
        cantidad_total: 0,
        utilidad: 0,
        utilidad2: 0,
        utilidad3: 0,
        pcu: 0,
        pvu: 0,
        pvu2: 0,
        pvu3: 0,
        obs: "",
        link_photo: "",
        icon: "",
        zoom: 0,
        fotox: 0,
        fotoy: 0,
    //    proveedor: {nombre:""},
        categoria: {descripcion:""},
      },

date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),












        rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres'
                },
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido"
              //,
            //  (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
            ],
        
    
  }),
  created(){

       }
  ,mounted(){



      this.listarProductos();
    
      this.tab="two";

   
    },

  methods: {

despuesDeActualizarPadreProducto(cat){

  console.log("Ingrese elemento padre de categoria que es Producto");
  console.log(cat);

  this.producto.categoria=cat;

 // this.producto.categoria_id=cat.id;


}
,
    

openCategoriaDialog() {
 // this.categoriaSeleccionado = { ...categoria }

  
      this.$refs.componenteEnPadre.openDialog();
   

},

    
  recibirCategoria:function(categoria){

      console.log('En elemento padre Producto');
        console.log(categoria);
     // this.categoria=categoria
      this.producto.categoria=categoria;

     // this.reCategoria=categoria;
    //  this.dependencia.categoria=categoria;
    },
  
		formatDate (date) {
		        if (!date) return null
		
		        const [year, month, day] = date.split('-')
		        return `${day}-${month}-${year}`
		      },
		      parseDate (date) {
		        if (!date) return null
		
		        const [year, month, day] = date.split('-')
		        return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
		      },

    despuesDeActualizar(){

 let mensajeText = 'Actualizado correctamente...';


        this.mensaje.text=mensajeText;

        this.mensaje.color="success";
 this.mensaje.colorBtn="green darken-1";

 this.mensaje.snackbar="true";

 this.listarProductos();


    },

openEditarProductoDialog(producto) {
  this.productoSeleccionado = { ...producto }

 // this.productoSeleccionado = producto; ESTE SE USA Y modifica a la par

      this.$refs.editarProductoDialog.openDialog(this.productoSeleccionado)
   

},

   





    listarProductos() {
      productoService
        .listarProductos()
        .then((resposta) => {
      //    console.log(resposta.data);
          this.productos = resposta.data;
        })
  
  },
    registrar(){
    if (this.$refs.form.validate()) {
   
         // if(this.producto.id===""||this.producto.id===null){
      //Eliminar para que funcione el auto incrementable
       // delete this.producto.id;
       //   }

        console.log(this.producto);

   

          productoService.save(this.producto,this.config).then(resposta=>{
           this.limpiar();
             
              let mensajeText = 'Registro exitoso';
          this.mensaje.text=mensajeText;
           this.mensaje.color="success";
 this.mensaje.colorBtn="green darken-1";
          this.mensaje.snackbar="true";

              this.listarProductos();
               this.selectedTab="second";
          }).catch((errors) =>{

          let mensajeError = 'Ha ocurrido un error:\n';

  // Recorremos el array de errores del backend
  if (errors.response && errors.response.data && errors.response.data.errors) {
    errors.response.data.errors.forEach((err, index) => {
      mensajeError += `${index + 1}. ${err}\n`;
    });
  } else {
    mensajeError += 'Error desconocido';
  }

  // Asignamos al snackbar
  this.mensaje.text = mensajeError;
  this.mensaje.snackbar = true; // debe ser boolean
  this.mensaje.color = "error"; // fondo rojo
  this.mensaje.colorBtn = "red darken-2"; // color de botón contraste


  })

      }
    },
   
    eliminarProducto(producto){

        if(confirm('Desea remover al producto')){


         



        
        productoService.delete(producto).then(resposta=>{

           let mensajeText = 'Registro eliminado correctamente';
          this.mensaje.text=mensajeText;
           this.mensaje.color="success";
 this.mensaje.colorBtn="green darken-1";
          this.mensaje.snackbar="true";



          this.listarProductos();
          //this.errors=[]
          this.limpiar();

        }).catch(e=>{

          let mensajeError = 'Ha ocurrido un error:\n';

  // Recorremos el array de errores del backend
  if (errors.response && errors.response.data && errors.response.data.errors) {
    errors.response.data.errors.forEach((err, index) => {
      mensajeError += `${index + 1}. ${err}\n`;
    });
  } else {
    mensajeError += 'Error desconocido';
  }

  // Asignamos al snackbar
  this.mensaje.text = mensajeError;
  this.mensaje.snackbar = true; // debe ser boolean
  this.mensaje.color = "error"; // fondo rojo
  this.mensaje.colorBtn = "red darken-2"; // color de botón contraste



        })

        }


        


    },
    limpiar(){

      this.date=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
           this.dateFormatted=this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
     

     
		this.producto = {
  id: '',                // id del producto
  descripcion: '',       // string
  sub1: "",
  sub2: "",
  sub3: "",
  sub4: "",
  sub5: "",
  info: "",
  estado: 'activo',            // activo / inactivo
  modelo: '',            // string
  ultima_compra: this.dateFormatted,
  codigo_barra: '',      // string
  cantidad_total: 0,     // decimal
  utilidad: 0,           // decimal
  utilidad2: 0,          // decimal
  utilidad3: 0,          // decimal
  pcu: 0,                // decimal
  pvu: 0,                // decimal
  pvu2: 0,               // decimal
  pvu3: 0,               // decimal
  obs: '',               // text
  
  // datos imagen
  link_photo: '',        // string
  icon: '',              // string
  zoom: 0,               // int
  fotox: 0,              // int
  fotoy: 0,              // int

  // relaciones
 // proveedor: {nombre:""},
        categoria: {descripcion:""},
};


        
    },
		
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  },

    watch: {
      date (val) {
        
				this.dateFormatted = this.formatDate(this.date)
		        this.producto.ultima_compra=this.dateFormatted;
        
       
      },
    },
  computed:{
    


    	
    productosBuscados() {
          return this.productos.filter(producto => {
            return producto.descripcion.toLowerCase().includes(this.buscador.toLowerCase());
          });
    
      }
    	
    
    
      
    
  
  },
};
</script>




